<template>
  <div class="wrap" v-if="!pageLoading">
    <div class="header">
      <div class="rule" @click="handleShowRule">规则</div>
      <div class="header-price"><span>¥</span>{{ packageFaceValue }}</div>
    </div>
    <div class="content">
      <HbBenefit
        v-for="item in categoryList"
        :key="item.id"
        :item="item"
        :card="card"
        v-show="isShow(item)"
      />
      <div class="footer">
        <div @click="handleToOrder">
          <img
            src="https://common-h5-dev.xiangshuheika.com/static/upload/20250924cfe0bf1157036.png"
          />我的订单
        </div>
      </div>
    </div>
    <van-popup
      v-model="showRule"
      position="center"
      class="rule-wrap"
      :close-on-click-overlay="false"
    >
      <div class="rule-title">活动规则</div>
      <div class="rule-content">
        您已成功开通惠享服务，卡费{{ weicaiInfo.payment_amount }}元，分{{
          weicaiInfo.total_tenor
        }}期支付
      </div>
      <div class="rule-btn" @click="handleCloseRule">我知道了</div>
    </van-popup>
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  onMounted,
  computed,
} from "@vue/composition-api";
import Vue from "vue";

import { jsonSafeParse } from "@/utils";
import { getWeicaiPrice } from "@/apis/weicai";
import { getPackageList } from "@/apis/product";
import { useRouter, useStore } from "@/components/use/base";
import useMoreCard from "@/use/useMoreCard";
import HbBenefit from "@/views/index/moreCard/visitor/component/common/HbBenefit.vue";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    HbBenefit,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const { initMoreCard, card, categoryList } = useMoreCard();

    const weicaiInfo = ref({});
    const showRule = ref(false);
    const packageFaceValue = ref(0);
    const pageLoading = ref(false);

    const namespace = computed(() => store.state.namespace);
    const packageName = computed(() => store.state.userInfo.card_type);

    const fetchPackage = async () => {
      const { data } = await getPackageList({
        namespace: namespace.value,
        source: "default",
        package_name: packageName.value,
      });
      packageFaceValue.value = data?.[0].face_value;
    };

    onMounted(async () => {
      const loading = vm.$loading();
      pageLoading.value = true;
      try {
        await initPage();
        await fetchPackage();
        await initWeicaiPage();
      } catch (error) {
        console.log(error);
      } finally {
        loading.clear();
        pageLoading.value = false;
      }
    });

    const isShow = computed(() => (item) => {
      const productInfo = item.productInfo;
      const benefitList = card.value.benefit_list.map((item) => item.type);
      let show = false;
      productInfo.forEach((element) => {
        if (benefitList.includes(element.benefit_type)) show = true;
      });
      return show;
    });

    const initWeicaiPage = async () => {
      const { data } = await getWeicaiPrice({
        orderId: store.state.orderId,
      });
      weicaiInfo.value = data;
    };

    const initPage = async () => {
      const packageMap = jsonSafeParse(vm.$getConfigValue("WC_CARD_MAP"));
      const page = packageMap[namespace.value];
      await initMoreCard(page);
    };

    const handleToService = () => {
      router.push("/help");
    };

    const handleToOrder = () => {
      router.push("/order");
    };

    const handleShowRule = () => {
      showRule.value = true;
    };

    const handleCloseRule = () => {
      showRule.value = false;
    };

    return {
      card,
      categoryList,
      isShow,
      showRule,
      weicaiInfo,
      packageFaceValue,
      pageLoading,
      handleShowRule,
      handleToService,
      handleToOrder,
      handleCloseRule,
    };
  },
});
</script>

<style scoped lang="less">
.wrap {
  background: #eeeff3;
}
.header {
  width: 100%;
  height: 364px;
  background: url("https://common-h5-dev.xiangshuheika.com/static/upload/20251209c4b9509df957d.png")
    no-repeat center/100%;
  position: relative;

  .rule {
    width: 27px;
    height: 18px;
    background: rgba(254, 244, 240, 0.86);
    border-radius: 9px 0 0 9px;
    backdrop-filter: blur(10px);
    position: absolute;
    top: 9px;
    right: 0px;
    opacity: 0.68;
    font-weight: 400;
    font-size: 12px;
    color: #ff6839;
    line-height: 18px;
    text-align: center;
    padding-left: 5px;
  }

  .header-price {
    position: absolute;
    top: 134px;
    left: 50%;
    transform: translateX(-50%);
    font-family: LiGothicMed;
    font-size: 50px;
    color: #ff561a;
    line-height: 54px;
    text-align: center;
    font-style: normal;
    span {
      font-size: 24px;
    }
  }
}

.content {
  background: #ffffff;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}

.footer {
  margin: 24px 16px;
  height: 32px;
  background: #feece8;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 400;
  font-size: 15px;
  color: #333333;
  padding: 0 40px;
  line-height: 22px;
  > div {
    display: flex;
    align-items: center;
  }

  img {
    height: 22px;
    width: 20px;
    margin-right: 9px;
  }

  .line {
    width: 1px;
    height: 23px;
    background: #fff;
  }
}

.server-info {
  margin-top: 24px;
  margin-bottom: 24px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  line-height: 17px;
  text-align: center;
  span {
    color: #fc4b21;
  }
}

.rule-wrap {
  width: 292px;
  height: 172px;
  background: #ffffff;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 24px 0;

  .rule-title {
    font-weight: 600;
    font-size: 18px;
    color: #333333;
    line-height: 18px;
    text-align: center;
  }

  .rule-content {
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    line-height: 18px;
    text-align: center;
    margin-top: 24px;
  }

  .rule-btn {
    margin: 0 auto;
    margin-top: 24px;
    width: 244px;
    height: 40px;
    background: linear-gradient(90deg, #fc4920 0%, #fc9b55 100%), #ff561a;
    border-radius: 20px;

    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }
}
</style>
